const CARD_SWATCH_HOVER_CLASS = 'card-wrapper--swatch-hover';

class CardSwatches extends HTMLElement {
  connectedCallback() {
    // On touch a tap fires pointerover, then pointerleave, then navigates. Previewing
    // the variant there flashes the image twice on the way to the product page, so the
    // preview is only wired up where a pointer can actually rest on a swatch.
    if (!window.matchMedia('(hover: hover)').matches) return;

    this.wrapper = this.closest('.card-wrapper');
    this.image = this.wrapper ? this.wrapper.querySelector('.card__media img') : null;
    if (!this.image) return;

    this.defaultSrcset = this.image.getAttribute('srcset') || '';
    this.defaultSrc = this.image.getAttribute('src') || '';

    this.activate = this.activate.bind(this);
    this.reset = this.reset.bind(this);
    this.preload = this.preload.bind(this);

    this.addEventListener('pointerover', this.activate);
    this.addEventListener('focusin', this.activate);
    this.addEventListener('pointerleave', this.reset);
    this.addEventListener('focusout', this.reset);
    this.wrapper.addEventListener('pointerenter', this.preload, { once: true });
  }

  disconnectedCallback() {
    if (this.wrapper) this.wrapper.removeEventListener('pointerenter', this.preload);
  }

  preload() {
    this.querySelectorAll('[data-variant-src]').forEach((link) => {
      const image = new Image();
      image.src = link.dataset.variantSrc;
    });
  }

  activate(event) {
    const link = event.target.closest('[data-variant-srcset]');
    if (!link || !this.contains(link)) return;

    this.wrapper.classList.add(CARD_SWATCH_HOVER_CLASS);
    this.image.srcset = link.dataset.variantSrcset;
    if (link.dataset.variantSrc) this.image.src = link.dataset.variantSrc;
  }

  reset(event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;

    this.wrapper.classList.remove(CARD_SWATCH_HOVER_CLASS);
    this.image.srcset = this.defaultSrcset;
    this.image.src = this.defaultSrc;
  }
}

if (!customElements.get('card-swatches')) {
  customElements.define('card-swatches', CardSwatches);
}
